/* Becquet Voiture : recherche prédictive (suggestions pendant la saisie), 2026-09-28.
   Se branche sur tous les champs input[name="q"] du site (en-tête, page de recherche, accueil).
   Données : API Shopify /search/suggest.json (produits, collections, requêtes suggérées). */
(function () {
  if (window.bvPredictiveInit) return;
  window.bvPredictiveInit = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MIN = 2, DELAY = 170;
  var cache = {}, timer = null, ctrl = null, activeInput = null, items = [], cursor = -1, lastTerm = '';

  var fmt;
  try { fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }); } catch (e) { fmt = null; }
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return fmt ? fmt.format(n).replace(/ /g, ' ') : n.toFixed(2).replace('.', ',') + ' €';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function highlight(text, term) {
    var t = String(text || ''), words = norm(term).split(/\s+/).filter(function (w) { return w.length > 1; });
    if (!words.length) return esc(t);
    var n = norm(t), marks = [];
    words.forEach(function (w) { var i = n.indexOf(w); while (i > -1) { marks.push([i, i + w.length]); i = n.indexOf(w, i + w.length); } });
    if (!marks.length) return esc(t);
    marks.sort(function (a, b) { return a[0] - b[0]; });
    var out = '', pos = 0;
    marks.forEach(function (m) { if (m[0] < pos) return; out += esc(t.slice(pos, m[0])) + '<mark>' + esc(t.slice(m[0], m[1])) + '</mark>'; pos = m[1]; });
    return out + esc(t.slice(pos));
  }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function searchUrl(term) {
    return ROOT + 'search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last&type=product';
  }

  /* ---------- Panneau ---------- */
  var panel = document.createElement('div');
  panel.className = 'bvp';
  panel.id = 'bvp-panel';
  panel.setAttribute('role', 'listbox');
  panel.setAttribute('aria-label', 'Suggestions de recherche');
  panel.hidden = true;
  document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(panel); });
  if (document.body) document.body.appendChild(panel);

  function place() {
    if (!activeInput || panel.hidden) return;
    var box = activeInput.closest('form') || activeInput;
    var r = box.getBoundingClientRect();
    var vv = window.visualViewport;
    var vh = vv ? vv.height + vv.offsetTop : window.innerHeight;
    var vw = document.documentElement.clientWidth;
    var mobile = vw < 700;
    var left = mobile ? 8 : Math.max(8, Math.min(r.left, vw - Math.max(r.width, 420) - 8));
    var width = mobile ? vw - 16 : Math.max(r.width, 420);
    var top = r.bottom + 8;
    panel.style.left = left + 'px';
    panel.style.top = top + 'px';
    panel.style.width = width + 'px';
    panel.style.maxHeight = Math.max(180, vh - top - 12) + 'px';
  }

  function open() {
    panel.hidden = false;
    if (activeInput) activeInput.setAttribute('aria-expanded', 'true');
    place();
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
  }
  function close() {
    panel.classList.remove('is-open');
    panel.hidden = true;
    cursor = -1;
    if (activeInput) activeInput.setAttribute('aria-expanded', 'false');
  }

  function skeleton(term) {
    var rows = '';
    for (var i = 0; i < 4; i++) rows += '<div class="bvp-sk"><span class="bvp-sk__img"></span><span class="bvp-sk__lines"><span></span><span></span></span></div>';
    panel.innerHTML = '<div class="bvp-head">Recherche de « ' + esc(term) + ' »…</div>' + rows;
  }

  function render(term, data) {
    var res = (data && data.resources && data.resources.results) || {};
    var products = res.products || [], cols = res.collections || [], queries = (res.queries || []).filter(function (q) { return norm(q.text) !== norm(term); });
    var html = '';
    if (queries.length) {
      html += '<div class="bvp-queries">' + queries.slice(0, 4).map(function (q) {
        return '<a class="bvp-q" role="option" href="' + esc(searchUrl(q.text)) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/></svg>' + highlight(q.text, term) + '</a>';
      }).join('') + '</div>';
    }
    if (products.length) {
      html += '<div class="bvp-head">Produits</div><div class="bvp-products">' + products.map(function (p) {
        var cmp = parseFloat(p.compare_at_price_max), pr = parseFloat(p.price);
        var sale = cmp > pr;
        var pct = sale ? Math.round((1 - pr / cmp) * 100) : 0;
        var src = p.featured_image && p.featured_image.url || p.image;
        return '<a class="bvp-p" role="option" href="' + esc(p.url) + '">' +
          '<span class="bvp-p__img">' + (src ? '<img src="' + esc(img(src, 120)) + '" alt="" width="60" height="60" loading="lazy">' : '') + '</span>' +
          '<span class="bvp-p__body"><span class="bvp-p__title">' + highlight(p.title, term) + '</span>' +
          '<span class="bvp-p__price">' + (p.price_max && parseFloat(p.price_max) > pr ? '<small>dès </small>' : '') + '<strong>' + money(pr) + '</strong>' +
          (sale ? '<s>' + money(cmp) + '</s><em>-' + pct + '%</em>' : '') +
          (p.available === false ? '<i>Épuisé</i>' : '') + '</span></span>' +
          '<span class="bvp-p__go" aria-hidden="true">→</span></a>';
      }).join('') + '</div>';
    }
    if (cols.length) {
      html += '<div class="bvp-head">Collections</div><div class="bvp-cols">' + cols.slice(0, 4).map(function (c) {
        return '<a class="bvp-c" role="option" href="' + esc(c.url) + '">' + highlight(c.title, term) + '</a>';
      }).join('') + '</div>';
    }
    if (!products.length && !cols.length) {
      html += '<div class="bvp-empty"><strong>Aucun produit pour « ' + esc(term) + ' »</strong><span>Essayez un terme plus court ou le nom du modèle (Golf, F30, W205…).</span></div>';
    }
    html += '<a class="bvp-all" role="option" href="' + esc(searchUrl(term)) + '">Voir tous les résultats pour « ' + esc(term) + ' »<span aria-hidden="true">→</span></a>';
    panel.innerHTML = html;
    items = Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
    items.forEach(function (a, i) { a.id = 'bvp-opt-' + i; });
    cursor = -1;
  }

  function fetchSuggest(term) {
    if (cache[term]) { render(term, cache[term]); open(); return; }
    if (ctrl) try { ctrl.abort(); } catch (e) {}
    ctrl = window.AbortController ? new AbortController() : null;
    skeleton(term); open();
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { cache[term] = d; if (term === lastTerm) { render(term, d); open(); } })
      .catch(function (e) { if (e && e.name === 'AbortError') return; if (term === lastTerm) close(); });
  }

  function isSearchInput(el) {
    return el && el.tagName === 'INPUT' && el.name === 'q' && !el.hasAttribute('data-bv-no-predict') && el.closest('form');
  }
  function prep(el) {
    if (el.dataset.bvp) return;
    el.dataset.bvp = '1';
    el.setAttribute('autocomplete', 'off');
    el.setAttribute('role', 'combobox');
    el.setAttribute('aria-autocomplete', 'list');
    el.setAttribute('aria-controls', 'bvp-panel');
    el.setAttribute('aria-expanded', 'false');
    if (!el.getAttribute('enterkeyhint')) el.setAttribute('enterkeyhint', 'search');
    // Neutralise l'ancienne autocomplétion Turbo si elle existe
    var old = el.closest('form').querySelector('.search__results-wrapper');
    if (old) old.style.display = 'none';
  }

  function onInput(el) {
    activeInput = el;
    var term = el.value.trim();
    lastTerm = term;
    clearTimeout(timer);
    if (term.length < MIN) { close(); return; }
    timer = setTimeout(function () { fetchSuggest(term); }, DELAY);
  }

  document.addEventListener('focusin', function (e) {
    if (!isSearchInput(e.target)) return;
    prep(e.target);
    activeInput = e.target;
    if (e.target.value.trim().length >= MIN) onInput(e.target);
  });
  document.addEventListener('input', function (e) {
    if (!isSearchInput(e.target)) return;
    prep(e.target);
    onInput(e.target);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!activeInput || e.target !== activeInput || panel.hidden) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (!items.length) return;
      cursor = e.key === 'ArrowDown' ? (cursor + 1) % items.length : (cursor <= 0 ? items.length - 1 : cursor - 1);
      items.forEach(function (a, i) { a.classList.toggle('is-active', i === cursor); });
      items[cursor].scrollIntoView({ block: 'nearest' });
      activeInput.setAttribute('aria-activedescendant', items[cursor].id);
    } else if (e.key === 'Enter' && cursor > -1 && items[cursor]) {
      e.preventDefault();
      window.location.href = items[cursor].href;
    } else if (e.key === 'Escape') {
      close();
    }
  });

  document.addEventListener('pointerdown', function (e) {
    if (panel.hidden) return;
    if (panel.contains(e.target) || (activeInput && (e.target === activeInput || (activeInput.closest('form') || activeInput).contains(e.target)))) return;
    close();
  });
  document.addEventListener('submit', function (e) { if (isSearchInput(e.target.querySelector && e.target.querySelector('input[name="q"]'))) close(); }, true);
  window.addEventListener('resize', place);
  window.addEventListener('scroll', place, { passive: true });
  document.addEventListener('scroll', place, { passive: true, capture: true });
  if (window.visualViewport) { visualViewport.addEventListener('resize', place); visualViewport.addEventListener('scroll', place); }
})();
